import { Checkbox, ListItemText, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface CompanySizeSelectorItemProps {
	fieldName: string;
	value: number[];
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	setValue: UseFormSetValue<any>;
	companySizes: { id: number; value: string }[];
	error?: string;
}

export default function CompanySizeSelectorItem({
	fieldName,
	value = [],
	setValue,
	companySizes,
	error,
}: CompanySizeSelectorItemProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`manage-to-dos.${key}`);

	const handleChange = (event: SelectChangeEvent<number[]>) => {
		const selected = event.target.value as number[];

		setValue(fieldName, selected, {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	const handleSelectAll = (selectAll: boolean) => {
		setValue(fieldName, selectAll ? companySizes.map((companySize) => companySize.id) : [], {
			shouldValidate: true,
			shouldDirty: true,
		});
	};

	return (
		<Select
			displayEmpty
			fullWidth
			multiple
			error={!!error}
			renderValue={(selected: unknown) =>
				Array.isArray(selected) && selected.length > 0
					? selected
							.map((id) => companySizes.find((i) => i.id === id)?.value)
							.filter(Boolean)
							.join(", ")
					: ts("select-company-size")
			}
			value={value}
			onChange={handleChange}
		>
			<MenuItem key="-1" value="-1">
				<Checkbox
					checked={value.length === companySizes.length}
					sx={{ padding: "4px" }}
					onChange={() => handleSelectAll(value.length !== companySizes.length)}
				/>
				<ListItemText primary={ts("select-all")} sx={{ "& span": { m: 0 } }} />
			</MenuItem>
			{companySizes.map((companySize) => (
				<MenuItem
					key={companySize.id}
					sx={{ width: "100%", alignItems: "center", m: 0 }}
					value={companySize.id}
				>
					<Checkbox checked={value.includes(companySize.id)} sx={{ padding: "4px" }} />
					<ListItemText primary={companySize.value} sx={{ "& span": { m: 0 } }} />
				</MenuItem>
			))}
		</Select>
	);
}
